<template>
  <el-tabs v-model="activeTab" class="dense agent-widget">
    <el-tab-pane label="Workflows" name="workflows">
      <AgentWorkflows :tenant="tenant" />
    </el-tab-pane>
  </el-tabs>
</template>
<script>
import AgentWorkflows from "@/system/pages/agent/workflows.vue";
export default {
  name: "AgentWidget",
  components: {
    AgentWorkflows,
  },
  props: {
    tenant: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      activeTab: "workflows",
    };
  },
};
</script>
<style lang="scss" scoped>
.agent-widget::v-deep {
  .el-tabs__content {
    @apply h-[calc(100vh_-_230px)] overflow-auto;
    .el-tab-pane {
      @apply h-full;
    }
  }
}
</style>
